export enum EChatAction {
  GroupDelete = 'groupDelete',
  Delete = 'delete',
  Block = 'block',
}

export type TChatActionModalState = {
  isOpened: boolean;
  text?: string;
  buttonText?: string;
  chatAction?: EChatAction;
};
